export const mapOffersDataToSelectedProducts = (data) => {
    if (!data) {
        return [];
    }
    return Object.values(data).map((offer) => ({
        id: offer.id,
        name: offer.name,
        image: offer.primaryImage?.thumbnail.url,
        status: offer.state.status,
    }));
};
